import { observable } from "mobx";

export class CVEQuestionStepContextStore {
  @observable hasClickedSubmit = false;
}
